import { render, staticRenderFns } from "./EventOverviewInstitution.vue?vue&type=template&id=172a9f69&scoped=true"
import script from "./EventOverviewInstitution.vue?vue&type=script&lang=js"
export * from "./EventOverviewInstitution.vue?vue&type=script&lang=js"
import style0 from "./EventOverviewInstitution.vue?vue&type=style&index=0&id=172a9f69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172a9f69",
  null
  
)

export default component.exports